import { apiService } from './api';
import { DocumentCategory, FacilityDocument } from '../types';

const path = (facilityId: string) => `/facilities/${facilityId}/documents`;
export const facilityDocumentsService = {
  list(facilityId: string): Promise<FacilityDocument[]> {
    return apiService.get(path(facilityId));
  },
  async upload(facilityId: string, file: File, category: DocumentCategory, title: string): Promise<FacilityDocument> {
    const body = new FormData();
    body.append('file', file); body.append('category', category); body.append('title', title);
    const response = await fetch(`${apiService.getBaseUrl()}${path(facilityId)}`, { method: 'POST', headers: await apiService.authHeaders(), body });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(typeof error.detail === 'string' ? error.detail : 'Could not upload document');
    }
    return response.json();
  },
  update(facilityId: string, id: string, payload: Pick<FacilityDocument, 'title' | 'category' | 'include_in_reports'>): Promise<FacilityDocument> {
    return apiService.patch(`${path(facilityId)}/${id}`, payload);
  },
  delete(facilityId: string, id: string): Promise<void> {
    return apiService.delete(`${path(facilityId)}/${id}`);
  },
  async download(facilityId: string, id: string): Promise<Blob> {
    const response = await fetch(`${apiService.getBaseUrl()}${path(facilityId)}/${id}/download`, { headers: await apiService.authHeaders() });
    if (!response.ok) throw new Error('Could not download document');
    return response.blob();
  },
};
